import Http from '@/utils/http'
import { RequestType } from '@/typings/enum/Common'
import NLoginApi = global.NLoginApi

class BankCardIQC extends Http {
  [x: string]: any
  public async getBankCardIQC(data: NLoginApi.getBankCardIQCRequestData) {
    return await super.request<NLoginApi.getBankCardIQCResponse>({
      url: '/crossbowSystem/getBankCardIQC',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      data
    })
  }

  public async addBankCardIQC(data: NLoginApi.addBankCardIQCRequestData) {
    return await super.request<NLoginApi.addBankCardIQCResponse>({
      url: '/crossbowSystem/addBankCardIQC',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/json'
      },
      data
    })
  }

  public async delBankCardIQC(data: NLoginApi.delBankCardIQCRequestData) {
    return await super.request<NLoginApi.delBankCardIQCResponse>({
      url: '/crossbowSystem/delBankCardIQC',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      data
    })
  }

  public async updateBankCardIQC(data: NLoginApi.updateBankCardIQCRequestData) {
    return await super.request<NLoginApi.updateBankCardIQCResponse>({
      url: '/crossbowSystem/updateBankCardIQC',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/json'
      },
      data
    })
  }
}

export default BankCardIQC
